export type Status = "yes" | "no" | "unknown";

/**
 * Strictly compare two values.
 * @param reference - The reference value to compare against, it can never be undefined or null.
 * @param value - The value to compare.
 * @returns "yes" if the values are strictly equal, "no" if they are not, and "unknown" if the value is undefined.
 */
export function strictIsEqual<T>(
  reference: Exclude<T, undefined | null>,
  value: unknown
): Status {
  if (value === undefined) {
    return "unknown";
  }
  return value === reference ? "yes" : "no";
}
